import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Paper } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        textAlign: 'center'
    },
}));

function getSteps() {
    return ['Process Started', 'In Process', 'Completed'];
}

// Decide active step based on job_progress
const getActiveStep = (progress) => {
    if (progress === 0) return 0;
    if (progress > 0 && progress < 100) return 1;
    if (progress === 100) return 2;
    return 0;
};

function StepperFile({ assessmentData }) {
    const classes = useStyles();
    const steps = getSteps();

    const progress = Number(assessmentData?.progress || 0);
    const activeStep = getActiveStep(progress);
    return (
        <Paper className={classes.root} square style={{ margin: '5px 0px 5px 0px' }}>
            <Stepper activeStep={progress === 100 ? 100 : activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            {/* <Typography className={classes.instructions}>
                {steps[activeStep]}
            </Typography> */}
        </Paper>
    );
}

export default StepperFile;
